import React, { useState, useEffect, useMemo } from 'react';
import { useSelector,shallowEqual ,useDispatch}      from 'react-redux';
import Home from '../components/LandingPage/home';
import Countdown from '../components/LandingPage/countdown';
import About from '../components/LandingPage/about';
import Speaker from '../components/LandingPage/speaker';
import ConferenceSchedule from '../components/LandingPage/conferenceSchedule';
import Sponsors from '../components/LandingPage/sponsor';
import Register from '../components/LandingPage/Registeration/register';
import Client from '../components/LandingPage/client';
import Footer from '../components/Layout/footer';
import Header from '../components/Layout/header';
import NavBar from '../components/Layout/navbar';
import HighLights from '../components/LandingPage/Components/Highlights';
import Faq from '../components/LandingPage/faq';
import Exhibitors from '../components/LandingPage/exhibitors';
import  Statistics from  '../components/LandingPage/Components/Statistics';
import { getSocialLinksByEventId } from '../api/eventApi';

import '../assets/styles/animate.css'
import '../assets/styles/bootstrap.css'
import '../assets/styles/headline.css'
import '../assets/styles/icon_fonts.css'
import '../assets/styles/jquery.mb.YTPlayer.css'
import '../assets/styles/owl.carousel.css'
import '../assets/styles/particles.css'
import '../assets/styles/sweetalert.css'
import '../assets/styles/style.css'

import axios from 'axios';
import { API_GATEWAY_URL,API_EVENT_USERS_URL_EMAIL } from '../config/constants';
import UserHelper from '../common/utils/userHelper';
import Gallery from '../components/LandingPage/gallery';

import { fetchExhibitorsCount } from '../api/exhibitorsApi';
import { fetchEventParticipantCount,fetchSpeakersAndPanelists } from '../api/eventUserApi';
import { setExhibitorCount,setPartipantCount,setSpeakersCount } from '../store/Actions/Event/eventActions';
import { useSearchParams } from 'react-router-dom';
import EmailVerify from '../components/LandingPage/Components/emailVerify';
import ForgotPassword from "../components/Auth/Login/forgotPassword";
import ResetPassword from '../components/Auth/Login/resetPassword';



type SectionItem = {
  label: string;
  key: string;
  is_show: boolean;
  sort_order: number | null;
  [key: string]: any;
};

type LandingPageData = {
  show_social_header?: boolean;
  is_header_banner_video: boolean;
  header_banner_image: any;
  header_banner_video: any;
  sections: SectionItem[];
  mid_section:any
};

const LandingPage: React.FC = () => {
  const eventId           = UserHelper.getEventId();
  const userId            = UserHelper.getUserId();
  const [data, setData]   = useState<LandingPageData>();
  const eventData                            = useSelector((state: any) => state.eventData); 
  const [socialData, setSocialData]          = useState<any>();

  const [isScheduleVisible, setIsScheduleVisible] = useState(false);
  const [scheduleLabel, setScheduleLabel] = useState("");

  const [isSpeakerVisible, setIsSpeakerVisible] = useState(false);
  const [speakerLabel, setSpeakerLabel] = useState("");

  const [emailStatus, setEmailStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [searchParams] = useSearchParams();

  const isForgot = searchParams.has("forgot");

  const isResetPassword = searchParams.has("password-reset");
  const passwordResetToken = searchParams.get("password-reset");
  const isPasswordReset = !!passwordResetToken;

  const dispatch = useDispatch();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${API_GATEWAY_URL}frontend/api/landing-page/event-id/${eventId}`
        );

        const pageData = res.data.data;
        setData(pageData);

        if (pageData) {
          const scheduleSection = pageData.mid_section?.find(
            (s: any) => s.key === "schedule"
          );

          const speakerSection = pageData.mid_section?.find(
            (s: any) => s.key === "speakers"
          );

          // Schedule
          setIsScheduleVisible(scheduleSection?.is_show ?? false);
          setScheduleLabel(scheduleSection?.label ?? "");

          // Speakers
          setIsSpeakerVisible(speakerSection?.is_show ?? false);
          setSpeakerLabel(speakerSection?.label ?? "");
        }
      } catch (error) {
        console.error("Error fetching landing page data:", error);
      }
    };

    fetchData();
  }, [eventId]);

  useEffect(() => {
    const getExhibitorsCount = async () => {
      if (!eventData._id) return;
      const count = await fetchExhibitorsCount(eventData._id)
      dispatch(setExhibitorCount(count));
    };

    const getParticipantsCount = async () => {
      if (!eventData._id) return;
      const count = await fetchEventParticipantCount(eventData._id);
      //setPartipantCount(count);
      dispatch(setPartipantCount(count));
    };

    const getSpeakersCount = async () => {
      if (!eventData._id) return;
      const count = await fetchSpeakersAndPanelists(eventData._id);
      dispatch(setSpeakersCount(count));
    };

    getExhibitorsCount();
    getParticipantsCount();
    getSpeakersCount();
  }, [eventData._id]);

  useEffect(() => {
    const fetchSocialData = async () => {
      try {
        let resposne = await getSocialLinksByEventId(eventData._id);
        setSocialData(resposne);
      } catch (error) {
        console.error('Error fetching gallery page data:', error);
      }
    };

    fetchSocialData();
  }, [eventId]);


  /*Email Verify Logic*/
  // Email Verification Logic
useEffect(() => {
  const token = searchParams.get("email_token");

  if (!token) return; // No email verification requested

  const verifyEmail = async () => {
    setEmailStatus("loading");
    try {
      const decodeToken = decodeURI(token);
      console.log("Decode***********",decodeToken);
      await axios.post(`${API_EVENT_USERS_URL_EMAIL}event-user/verify-email`, { token: decodeToken });
      setEmailStatus("success");
    } catch (err) {
      setEmailStatus("error");
    }
  };

  verifyEmail();
}, []);


  const renderSection = (section: SectionItem) => {
    if (!section.is_show) return null;

    switch (section.key) {
      case 'countdown_timer':
        return <Countdown  eventData={eventData} />;
      case 'welcome_note':
        return <About landingPageData={data}  eventData={eventData} />; // Use your actual component
      case 'gallery':
        return <Gallery landingPageData={data} label={section.label}/>;
      case 'sponsors':
        return <Sponsors landingPageData={data} label={section.label}/>;
      case 'faq':
        return <Faq  />;
      case 'schedule':
        return <ConferenceSchedule landingPageData={data}  label={section.label}/>;
        
      case 'agenda':
        return <HighLights landingPageData={data} label={section.label}/>;
      case 'speakers':
        return <Speaker landingPageData={data} label={section.label}/>;
      case 'exhbitors':
        return <Exhibitors landingPageData={data} label={section.label}/>;
     /* case 'speaker_statistics':
        return <Statistics/>;*/

      default:
        return null;
    }
  };

return (
  <>
    {isForgot ? (
      <ForgotPassword />
    ) : isPasswordReset ? (
      <ResetPassword email_token={passwordResetToken} />
    ) : (
      <>
        <NavBar
          isSocialHeader={data?.show_social_header}
          socialData={socialData}
          midSectionSettings={data?.mid_section}
        />

        {data && (
          <Home
            isVideo={data.is_header_banner_video}
            image={data.header_banner_image}
            video={data.header_banner_video}
            isSpeakersVisible={isSpeakerVisible}
            isScheduleVisible={isScheduleVisible}
            landingPageData={data}
            scheduleLabel={scheduleLabel}
            speakerLabel={speakerLabel}
          />
        )}

        {emailStatus !== "idle" && (
          <EmailVerify emailStatus={emailStatus} />
        )}

        {emailStatus === "idle" && (
          <>
            {data?.mid_section.map(section => renderSection(section))}
            <Register landingPageData={data} />
          </>
        )}

        <Footer
          isSocialFooter={data?.show_social_footer}
          socialData={socialData}
          show_partners_footer={data?.show_partners_footer}
          show_newsletter_footer={data?.show_newsletter_footer}
          data={data}
        />
      </>
    )}
  </>
);



  

};

export default LandingPage;
